const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  roles: state => state.user.roles,
  setting: state => state.user.setting,
  errorLogs: state => state.errorLog.logs,
  floatingData: state => state.home.floatingData,
  floatingVisible: state => state.home.floatingVisible,
  projectList: state => state.project.projectList,
  clientChildren: state => state.project.clientChildren,
  company: state => state.project.company,
  pageData: state => state.baseData.pageData

}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js